export * from './umpire-component-image';
